var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"border":"0"},attrs:{"width":"100%","height":"100%","src":"https://datastudio.google.com/embed/reporting/84c5ebd6-7d4a-43e8-bcac-0eeca2f820fa/page/6zXD","frameborder":"0","allowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }